import pageHeaderBg from "@/assets/landingPage/page-header/page-header-bg.png";
const PageHeader = ({ title }) => {
  return (
    <div className="page-header mt-[110px] sm:mt-[130px]">
      <div
        className="bg-cover bg-no-repeat w-full h-full py-[30px] sm:py-[48px]"
        style={{ backgroundImage: `url(${pageHeaderBg.src})` }}
      >
        <div className="custom-container mx-auto">
          <h3 className="text-white text-[24px] sm:text-[26px] lg:text-[30px] 2xl:text-[40px] font-semibold text-center">
            {title}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
